import React, {useState}from "react";
import { joiningDebate } from "../../../redux/actions/joining_debate_action";
import {useForm} from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import axiosInstance from "../../../services/axios";
import { ToastContainer, toast } from 'react-toastify';
import { RoomIdProvider } from "../../../redux/actions/websocket_actions/roomId_action";


function Join(){
    const {
        handleSubmit,
        register,
        formState: { errors, isSubmitting},
    }=useForm();

    const notificaton = ()=>{
        toast('Room Is Full..', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            });
    }
    const navigate = useNavigate();
    const joined_debate = useSelector((state)=>state.joiningDebateReducer);
    const {roomId} = useSelector((state)=>state.roomIdReducer);

    const dispatch = useDispatch();

    const onSubmit = async (values) =>{
        try{
            await axiosInstance.get(`join/check/member/count/`,{params:{code:values.code}}).then((res)=>{
                
                if(res.data.room_exist){
                    values.type = res.data.joined_as
                    dispatch(joiningDebate(values,navigate));
                }
                if(!res.data.room_exist){
                    notificaton()
                }
            })
        }
        catch(err){
            throw(err)
        }
        // dispatch(joiningDebate(values));
       
        // navigate("/participants",{replace: true});
    }
    if(joined_debate.joined_as === "participants"){
        // navigate("/choose",{state:{joined_as:'participant',debate_id:joined_debate.debate_id,room_id:joined_debate.room_id,code:joined_debate.code}});
        navigate("/avatar",{state:{joined_as:'participant',debate_id:joined_debate.debate_id,room_id:joined_debate.room_id,code:joined_debate.code}});

    }
    if(joined_debate.joined_as === "audience"){
        if(roomId === null){
            dispatch(RoomIdProvider(joined_debate.room_id));
        }
        navigate("/audience",{state:{debate_id:joined_debate.debate_id,code:joined_debate.code,room_id:joined_debate.room_id}})
    }
   
    // console.log(joined_debate)
    return(
        <div className="loginWrapper">
            <div className="leftCol">
                <div className="content">
                    <img src={process.env.PUBLIC_URL +'img/bedater-logo.png' } alt="" title="" width="86" />
                    <h1>Join Debate</h1>
                    <p className="mb-0">Please enter code to join debate.</p>
                </div>
                <div className="graphicImg">
                    <img src={process.env.PUBLIC_URL+'img/login-debaters-img.png'} alt="" title="" />
                </div>
            </div>
            <div className="rightCol">
                <div className="form">
                    <form className="mb-0" method="POST" onSubmit={handleSubmit(onSubmit)}>
                        <div className="form-group">
                            <label htmlFor="enterCode">Enter Code</label>
                            <input type="text" className="form-control"  placeholder="code" name="code" {...register("code")}/>
                            <input type="hidden" name="team"  {...register("team")}/>
                            <small className="form-text invalid-feedback">Enter you code</small>
                        </div>
                        <input type="submit" className="btn btn-secondary w-100"  value="Ready Set Go!" />

                    </form>
                </div>
            </div>
        </div>

    );
}

export default Join;